export default {
  testbank: state => state.testbank,
  testbankListFilter: state => state.testbankListFilter,
  testbankExamListFilter: state => state.testbankExamListFilter,
  isCreate: state => state.view === 'testbank__exam_create',
  isEdit: state => state.view === 'testbank__exam_edit',
  isCopy: state => state.view === 'testbank__exam_copy',
  isView: (state, getters) => !getters.isCreate && !getters.isEdit && !getters.isCopy
}
